import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.index-of.js";
var _excluded = ["value"];
var _initialState;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { Box, GRAY, Grid, FormControl, FormControlLabel, RadioGroup, Radio, makeStyles, Typography } from '@applyboard/ui-components';
import { setField } from "../../../../store/Actions/Actions";
import ErrorMessage from "../ErrorMessage";
import { Keys } from "../Constants";
import { getApplication } from "../../../../store/Selectors";
import ExamScores from "./ExamScores";
import Score from "../Score";
import { ENGLISH_EXAM_TYPE_VALUES } from "./consts";
import LabelWrapper from "../LabelWrapper";
import { dontHaveOption, getNotYetHelperText, getNotYetLabel } from "../../Utilities/LanguageHelper";
import { useAppContext } from "../../Providers";
import { useLeadSource } from "../../Hooks/useLeadSources";
import { Divider, Notice } from '@applyboard/crystal-ui';
import { useEventTracker } from '@applyboard/ui-utils';
var useStyles = makeStyles({
  error: {
    marginBottom: '16px'
  },
  duolingo: {
    paddingBottom: '23px'
  },
  not_yet_info: {
    marginLeft: '30px',
    marginTop: '-8px',
    color: "".concat(GRAY[10])
  }
});
var initialState = (_initialState = {}, _defineProperty(_initialState, ENGLISH_EXAM_TYPE_VALUES.IELTS, {
  l: '',
  r: '',
  s: '',
  w: ''
}), _defineProperty(_initialState, ENGLISH_EXAM_TYPE_VALUES.TOEFL, {
  l: '',
  r: '',
  s: '',
  w: ''
}), _defineProperty(_initialState, ENGLISH_EXAM_TYPE_VALUES.PTE, {
  total: '',
  l: '',
  r: '',
  s: '',
  w: ''
}), _defineProperty(_initialState, ENGLISH_EXAM_TYPE_VALUES.DUOLINGO, {
  total: ''
}), _initialState);
var EnglishTests = function EnglishTests(props) {
  var _user$studentId$toStr, _user$studentId;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var name = props.name,
    englishProficiencyTest = props.englishProficiencyTest,
    error = props.error,
    validationError = props.validationError,
    clearError = props.clearError,
    showError = props.showError;
  var user = useAppContext();
  var _useLeadSource = useLeadSource((_user$studentId$toStr = user === null || user === void 0 ? void 0 : (_user$studentId = user.studentId) === null || _user$studentId === void 0 ? void 0 : _user$studentId.toString()) !== null && _user$studentId$toStr !== void 0 ? _user$studentId$toStr : ''),
    leadSource = _useLeadSource.leadSource;
  var allowedSourceNames = ['british_council_widget', 'British_Council_STULP'];
  var isBcStudent = leadSource && leadSource.some(function (source) {
    return allowedSourceNames.includes(source.name);
  });
  var isBcStudentWithoutTest;
  var classes = useStyles();
  var _useState = useState(_objectSpread({}, initialState)),
    _useState2 = _slicedToArray(_useState, 2),
    localTests = _useState2[0],
    setLocalTests = _useState2[1];
  var toeflVal = ENGLISH_EXAM_TYPE_VALUES.TOEFL;
  var ieltsVal = ENGLISH_EXAM_TYPE_VALUES.IELTS;
  var pteVal = ENGLISH_EXAM_TYPE_VALUES.PTE;
  var duolingoVal = ENGLISH_EXAM_TYPE_VALUES.DUOLINGO;

  // Run this useEffect only once after englishProficiencyTest
  // receives value from Redux store when the tests load.
  var calledOnce = React.useRef(false);
  // eslint-disable-next-line no-restricted-syntax -- TODO: refactor to use englishProficiencyTest as initial state
  useEffect(function () {
    if (calledOnce.current) {
      return;
    }
    if (englishProficiencyTest) {
      var _englishProficiencyTe = _objectSpread({}, englishProficiencyTest),
        value = _englishProficiencyTe.value,
        scores = _objectWithoutProperties(_englishProficiencyTe, _excluded);
      setLocalTests(_objectSpread(_objectSpread({}, localTests), {}, _defineProperty({}, value, _objectSpread({}, scores))));
      calledOnce.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO: fix this
  }, [englishProficiencyTest]);
  var handleChange = function handleChange(e) {
    var dto = {
      key: Keys.Application.englishProficiencyTest,
      value: null
    };
    var _e$target = e.target,
      eventName = _e$target.name,
      value = _e$target.value;
    clearError(name, eventName);
    isBcStudentWithoutTest = isBcStudent && eventName === 'eng_test';
    if (e.target.name === 'eng_test') {
      dto.value = _objectSpread({
        value: value
      }, localTests[value]);
    } else {
      var exam = englishProficiencyTest.value;
      setLocalTests(_objectSpread(_objectSpread({}, localTests), {}, _defineProperty({}, exam, _objectSpread(_objectSpread({}, localTests[exam]), {}, _defineProperty({}, eventName, value)))));
      dto.value = _objectSpread(_objectSpread({}, englishProficiencyTest), {}, _defineProperty({}, eventName, value));
    }
    props.setField(dto);
  };
  var type = englishProficiencyTest ? englishProficiencyTest.value : ' ';
  isBcStudentWithoutTest = isBcStudent && englishProficiencyTest.value === '';
  var noticeText = 'If you need an English test, purchase official IELTS test voucher directly from the British Council.';
  var noticeLink = 'https://takeielts.britishcouncil.org/take-ielts/book?utm_source=&utm_medium=referral&utm_campaign=exams-all-ielts-global-student-mobility-applyboard';
  return /*#__PURE__*/React.createElement("div", null, error && /*#__PURE__*/React.createElement(Box, {
    className: classes.error
  }, /*#__PURE__*/React.createElement(ErrorMessage, {
    message: error
  })), /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset",
    "aria-label": "English Tests"
  }, /*#__PURE__*/React.createElement(RadioGroup, {
    "aria-label": "english tests",
    name: "eng_test",
    value: type,
    onChange: handleChange
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: ieltsVal,
    control: /*#__PURE__*/React.createElement(Radio, null),
    label: /*#__PURE__*/React.createElement(LabelWrapper, null, "IELTS")
  }), type === ieltsVal && /*#__PURE__*/React.createElement(ExamScores, {
    exam: "IELTS",
    value: localTests[ENGLISH_EXAM_TYPE_VALUES.IELTS],
    onChange: handleChange,
    error: validationError,
    showError: showError
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: toeflVal,
    control: /*#__PURE__*/React.createElement(Radio, null),
    label: /*#__PURE__*/React.createElement(LabelWrapper, null, "TOEFL")
  }), type === toeflVal && /*#__PURE__*/React.createElement(ExamScores, {
    exam: "TOEFL",
    value: localTests[ENGLISH_EXAM_TYPE_VALUES.TOEFL],
    onChange: handleChange,
    error: validationError,
    showError: showError
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: pteVal,
    control: /*#__PURE__*/React.createElement(Radio, null),
    label: /*#__PURE__*/React.createElement(LabelWrapper, null, "PTE")
  }), type === pteVal && /*#__PURE__*/React.createElement(ExamScores, {
    exam: "PTE",
    value: localTests[ENGLISH_EXAM_TYPE_VALUES.PTE],
    onChange: handleChange,
    error: validationError,
    showError: showError
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: duolingoVal,
    control: /*#__PURE__*/React.createElement(Radio, null),
    label: /*#__PURE__*/React.createElement(LabelWrapper, null, "Duolingo")
  }), type === duolingoVal && /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    direction: "row",
    className: classes.duolingo
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Score, {
    exam: "Duolingo",
    name: "total",
    label: "Total Score",
    value: localTests[ENGLISH_EXAM_TYPE_VALUES.DUOLINGO].total,
    onChange: handleChange,
    error: validationError.message,
    showError: showError
  }))), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: ENGLISH_EXAM_TYPE_VALUES.DONT_HAVE,
    control: /*#__PURE__*/React.createElement(Radio, null),
    label: /*#__PURE__*/React.createElement(LabelWrapper, null, dontHaveOption())
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: ENGLISH_EXAM_TYPE_VALUES.PROVIDELATER,
    control: /*#__PURE__*/React.createElement(Radio, null),
    label: /*#__PURE__*/React.createElement(LabelWrapper, null, getNotYetLabel())
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    className: classes.not_yet_info
  }, getNotYetHelperText()))), isBcStudentWithoutTest && /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Divider, {
    direction: "horizontal"
  }), /*#__PURE__*/React.createElement(Notice, null, noticeText, /*#__PURE__*/React.createElement(Notice.ButtonLink, {
    href: noticeLink,
    mode: "override_user_choice_and_open_in_new_tab",
    onClick: function onClick() {
      trackEvent({
        group: 'CEF',
        event: 'Student Page - CEF - Clicked Buy IELTS BC'
      });
    }
  }, "Buy IELTS"))));
};
var mapStateToProps = function mapStateToProps(state) {
  var application = getApplication(state);
  return _defineProperty({}, Keys.Application.englishProficiencyTest, application.englishProficiencyTest);
};
var connector = connect(mapStateToProps, {
  setField: setField
});
export default connector(EnglishTests);